export default __webpack_public_path__ + "static/23-low-life-punk-889ac23305ad71751af9de26aa53af06.png";